<template>
  <div>
    <el-form :model="formEdit" class="formEdit" ref="formEdit" :rules="rules" label-width="120px">
      <el-form-item :label="$t('setUp.oldPassword')" prop="ocipher">
        <el-input size="small" v-model="formEdit.ocipher" :type="showPassword1 ? 'text' : 'password'" maxlength="200"
          autocomplete="off"></el-input>
        <span class="svg-pwd-container">
          <svg-icon v-if="showPassword1" @click="showPassword1 = !showPassword1" icon-class="yanjing" />
          <svg-icon v-else @click="showPassword1 = !showPassword1" icon-class="biyanjing" />
        </span>
      </el-form-item>
      <el-form-item :label="$t('setUp.newPassword')" prop="ncipher">
        <el-input size="small" v-model="formEdit.ncipher" :type="showPassword2 ? 'text' : 'password'" maxlength="200"
          autocomplete="off"></el-input>
        <span class="svg-pwd-container">
          <svg-icon v-if="showPassword2" @click="showPassword2 = !showPassword2" icon-class="yanjing" />
          <svg-icon v-else @click="showPassword2 = !showPassword2" icon-class="biyanjing" />
        </span>
      </el-form-item>
      <el-form-item :label="$t('setUp.reconfirm')" prop="cpd">
        <el-input size="small" v-model="formEdit.cpd" :type="showPassword3 ? 'text' : 'password'" maxlength="200"
          autocomplete="off"></el-input>
        <span class="svg-pwd-container">
          <svg-icon v-if="showPassword3" @click="showPassword3 = !showPassword3" icon-class="yanjing" />
          <svg-icon v-else @click="showPassword3 = !showPassword3" icon-class="biyanjing" />
        </span>
      </el-form-item>
    </el-form>
    <div style="text-align: right">
      <el-button @click="cancleCommit" size="small">取 消</el-button>
      <el-button type="primary" @click="commitButton" size="small">确 定</el-button>
    </div>
  </div>
</template>

<script>
import { updatePassword } from "@/api/user";
import JSEncrypt from "../../utils/jsencrypt.min.js";
export default {
  name: "",
  components: {},
  props: {},
  data() {
    // 失去焦距的判断两次密码不止一次的校验规则
    let validPassWorld = (rule, value, callback) => {
      this.ncipherValid = true;
      if (this.formEdit.ncipher !== value && this.cpdValid) {
        callback(new Error("两次密码输入不一致"));
        return;
      }
      if (
        this.formEdit.ncipher.length >= 6 &&
        this.formEdit.ncipher.length <= 20
      ) {
        callback();
        this.$refs.formEdit.clearValidate("ncipher");
      }
    };
    // 失去焦距的判断两次密码不止一次的校验规则
    let validCpd = (rule, value, callback) => {
      this.cpdValid = true;
      if (this.formEdit.cpd !== value && this.cipherValid) {
        callback(new Error("两次密码输入不一致"));
        return;
      }

      callback();
      this.$refs.formEdit.clearValidate("cpd");
    };
    return {
      formEdit: {
        ncipher: "",
        ocipher: "",
        cpd: ""
      },
      showPassword1: false,
      showPassword2: false,
      showPassword3: false,
      rules: {
        ocipher: [{ required: true, message: "请输入旧密码" }],
        ncipher: [
          { required: true, message: "请输入新密码" },
          {
            pattern: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])[0-9a-zA-Z]{8,16}$/,
            message: "支持8-16位字符，必须包含数字，大小写字母",
            trigger: "blur",
          },
          {
            validator: validCpd,
            trigger: "blur",
          },
        ],
        cpd: [
          { required: true, message: "请输入确认密码" },
          { validator: validPassWorld, trigger: "blur" },
          {
            pattern: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])[0-9a-zA-Z]{8,16}$/,
            message: "支持8-16位字符，必须包含数字，大小写字母",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {},
  watch: {},
  created() { },
  mounted() { },
  methods: {
    updatePassword() {
      const publicKey = this.$store.state.user.pubKey; // 从后台获取公钥，这里省略，直接赋值
      const encryptor = new JSEncrypt(); // 新建JSEncrypt对象
      encryptor.setPublicKey(publicKey); // 设置公钥
      const oldPassword = encryptor.encrypt(this.formEdit.ocipher);
      const newPassword = encryptor.encrypt(this.formEdit.ncipher); // 对密码进行加密
      const option = {
        oldPassword: oldPassword,
        newPassword: newPassword,
      };
      updatePassword(option, ['修改密码']).then((res) => {
        this.$message.success('修改成功');
        this.$emit('closePwdVisible', '');
      });
    },
    commitButton() {
      this.$refs.formEdit.validate(valid => {
        if (valid) {
          this.updatePassword();
        }
      })
    },
    cancleCommit() {
      this.$emit('closePwdVisible', '');
    }
  },
};
</script>

<style scoped lang="scss">
.formEdit {
  margin-right: 20px;

  .el-form-item {
    margin-bottom: 15px;
  }
}

.svg-pwd-container {
  position: absolute;
  right: 10px;
  top: 0px;
  color: #181818;
  font-size: 20px;
  margin-top: 0px;
  cursor: pointer;
}

.el-form-item {
  position: relative;
}

.login-container {
  height: 100%;
  display: flex;
  flex-direction: column;

  ::v-deep .el-input {
    width: calc(100% - 100px);

    input {
      background: transparent;
      padding-right: 50px;
      // border: 0px;
      // padding: 12px 5px 12px 15px;
      color: #181818;
    }
  }
}
</style>
